<template>
	<div>
		<table>
			<thead>
				<tr class="body-text-1">
					<th class="th-question__type " @click="sortColumn('facility_ID')">
						<div class="th-sort">
							<span> {{ $t('facilityID') }} </span>
							<span v-if="sortedColumn === 'facility_ID'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th class="th-question__answer" @click="sortColumn('name')">
						<div class="th-sort">
							<span> {{ $t('facilityName') }}</span>
							<span v-if="sortedColumn === 'name'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th class="th-question__answer" @click="sortColumn('address')">
						<div class="th-sort">
							<span> {{ $t('address') }}</span>
							<span v-if="sortedColumn === 'address'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th class="th-question__text" @click="sortColumn('simulationType')">
						<div class="th-sort">
							<span> {{ $t('simulationType') }}</span>
							<span v-if="sortedColumn === 'simulationType'">
								<svgicon :name="isSorted ? 'arrowUp' : 'arrowDown'"> </svgicon>
							</span>
						</div>
					</th>
					<th class="th-question__actions">{{ $t('actions') }}</th>
				</tr>
			</thead>
			<tbody class="body-text-2">
				<tr class="search-row">
					<td class="td-input">
						<label class="custom-input">
							<svgicon name="search"> </svgicon>
							<input v-model="searchFacilityID" />
						</label>
					</td>
					<td class="td-input">
						<label class="custom-input">
							<svgicon name="search"> </svgicon>
							<input v-model="searchFacilityName" />
						</label>
					</td>
					<td class="td-input">
						<label class="custom-input">
							<svgicon name="search"> </svgicon>
							<input v-model="searchFacilityAddress" />
						</label>
					</td>
					<td class="td-input">
						<label class="custom-input">
							<svgicon name="search"> </svgicon>
							<input v-model="searchSimulationType" />
						</label>
					</td>
					<td></td>
				</tr>
				<tr
					v-for="(row, index) in displayedData"
					:key="index"
					class="table-row"
				>
					<td>{{ row.facility_ID }}</td>
					<td class="description-cell">{{ row.name }}</td>
					<td class="description-cell">{{ row.address }}</td>
					<td>{{ getSymTypeName(row.printShoppingTemplates) }}</td>
					<td class="td-center">
						<button class="action-button" @click="editRow(row)">
							<svgicon name="pencil"></svgicon>
						</button>
						<button class="action-button" @click="openDeleteModal(row)">
							<svgicon name="trash"></svgicon>
						</button>
					</td>
				</tr>
			</tbody>
		</table>
		<ja-pagination
			:current="currentPage"
			:data-per-page="itemsPerPage"
			:data-count="filteredData.length"
			@changePage="setAllPage"
		></ja-pagination>
		<ja-confirm-modal
			:show="showMessageDeletionModal"
			:title="$t('confirmation')"
			:confirm-text="$t('yes')"
			:cancel-text="$t('no')"
			class="confirm-modal--medium"
			@confirm="deleteFacility()"
			@closeModal="closeMessageDeletionModal()"
			@cancel="closeMessageDeletionModal()"
		>
			<h3 class="body-text-2">
				{{
					$t('deleteMessageCms', {
						title: titleDelete
					})
				}}
			</h3>
		</ja-confirm-modal>
	</div>
</template>
<script>
import Pagination from '@/components/AdminSection/elements/Pagination';
import ConfirmModal from '@/components/Modal/ConfirmModal.vue';
import { printShoppingTemplates } from '@/helpers/constants';
import '@/components/icons/cms/search';
import '@/components/icons/cms/pencil';
import '@/components/icons/cms/trash';
import '@/components/icons/cms/arrowDown';
import '@/components/icons/cms/arrowUp';

export default {
	components: {
		jaConfirmModal: ConfirmModal,
		jaPagination: Pagination
	},
	props: {
		data: {
			type: Array,
			required: true
		}
	},
	data() {
		return {
			showMessageDeletionModal: false,
			sortedColumn: null,
			sortOrder: 1,
			isSorted: false,
			currentPage: 1,
			itemsPerPage: 150,
			searchFacilityID: '',
			searchFacilityName: '',
			searchFacilityAddress: '',
			searchSimulationType: '',
			rowToDelete: null,
			titleDelete: 'record'
		};
	},
	computed: {
		filteredData() {
			let filteredData = this.data.filter(
				row =>
					row.facility_ID.toString().includes(this.searchFacilityID) &&
					row.name
						.toLowerCase()
						.includes(this.searchFacilityName.toLowerCase()) &&
					row.address
						.toLowerCase()
						.includes(this.searchFacilityAddress.toLowerCase()) &&
					this.getSymTypeName(row.printShoppingTemplates)
						.toLowerCase()
						.includes(this.searchSimulationType.toLowerCase())
			);

			if (this.sortedColumn) {
				filteredData = filteredData.sort((a, b) => {
					const fieldA = a[this.sortedColumn];
					const fieldB = b[this.sortedColumn];
					return (fieldA > fieldB ? -1 : 1) * this.sortOrder;
				});
			}
			return filteredData;
		},
		displayedData() {
			const start = (this.currentPage - 1) * this.itemsPerPage;
			const filteredData = this.filteredData.slice(
				start,
				start + this.itemsPerPage
			);
			return filteredData;
		},
		totalPages() {
			return Math.ceil(this.data.length / this.itemsPerPage);
		},
		showPagination() {
			return this.totalPages > 1;
		}
	},
	watch: {
		displayedData() {
			this.currentPage = this.currentPage <= 0 ? 1 : this.currentPage;
		}
	},
	methods: {
		getSymTypeName(isPrintShopping) {
			const simulationType = printShoppingTemplates.find(
				print => print.value === isPrintShopping
			);
			return simulationType ? simulationType.name : '';
		},
		sortTable() {
			this.sortOrder = this.sortOrder * -1;
			this.sortedColumn = null;
		},
		sortColumn(column) {
			this.sortedColumn = column;
			this.sortOrder = this.sortOrder * -1;
			this.isSorted = !this.isSorted;
		},
		changePage(pageNumber) {
			this.currentPage = pageNumber;
		},
		editRow(row) {
			this.$emit('editRow', row);
		},
		openDeleteModal(row) {
			this.titleDelete = row.facility;
			this.rowToDelete = row;
			this.showMessageDeletionModal = true;
		},
		setAllPage(page) {
			this.currentPage = page;
		},
		deleteFacility() {
			if (this.rowToDelete) {
				this.$emit('deleteRow', this.rowToDelete);
			}
			this.showMessageDeletionModal = false;
		},
		closeMessageDeletionModal() {
			this.showMessageDeletionModal = false;
		}
	}
};
</script>
<style lang="scss" scoped>
table {
	width: 100%;
	border-collapse: collapse;
	margin-top: 10px;
}
.td-input {
	padding: 0;
}
.th-question {
	&__type {
		width: 12%;
	}
	&__text {
		width: 16%;
	}
	&__answer {
		width: 31%;
	}
	&__actions {
		width: 10%;
	}
}
.td-center {
	text-align: center;
	text-align: -webkit-center;
}
.container-evaluation-question {
	display: flex;
	flex-direction: column;
	gap: 20px;
}
.description-cell {
	max-width: 60px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.custom-input {
	display: flex;
	border-radius: 4px;
	border: 1px solid #ddd;
	box-shadow: inset 0 0 5px 0px rgba(0, 0, 0, 0.15);
	padding: 7px 5px;
	margin: 1px;
	gap: 5px;
}

.custom-input input {
	border: none;
	outline: none;
	width: 100%;
}
.custom-input:focus-within {
	outline: 2px solid $hover-state;
	box-shadow: inset 0 0 5px 0px rgba(0, 0, 0, 0.15);
}
.action-button {
	background-color: transparent;
	border: none;
	cursor: pointer;
	padding: 0 10px;
}
.th-sort {
	cursor: pointer;
	display: flex;
	justify-content: space-between;
}

th,
td {
	border: 1px solid #ddd;
	padding: 8px;
	text-align: left;
}

th {
	background-color: #ffff;
}
</style>
